import { Badge } from '@/components/ui/badge'
import type { EngagementStatus } from '@/types'

const STATUS_CONFIG: Record<
  EngagementStatus,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }
> = {
  scheduled:           { label: 'Scheduled',           variant: 'secondary'   },
  awaiting_acceptance: { label: 'Pending Your Review', variant: 'outline'     },
  awaiting_payment:    { label: 'Deposit Due',         variant: 'outline'     },
  confirmed:           { label: 'Confirmed',           variant: 'default'     },
  in_progress:         { label: 'In Progress',         variant: 'default'     },
  delivered:           { label: 'Delivered',           variant: 'outline'     },
  cancelled:           { label: 'Cancelled',           variant: 'destructive' },
}

interface EngagementStatusBadgeProps {
  status: EngagementStatus
}

export function EngagementStatusBadge({ status }: EngagementStatusBadgeProps) {
  const { label, variant } = STATUS_CONFIG[status]
  return <Badge variant={variant}>{label}</Badge>
}
